import ImageOptimize from '@/components/ImageOptimize'
import { MenuWrapper } from '@/components/MenuWrapper'
import { PageType, SaleChannel } from '@/constants'
import { useAuth, useNotification, useStore } from '@/containers'
import { EventBus, bus } from '@/hooks/useEventBus'
import {
  IconCart,
  IconCategory,
  IconClose,
  IconNotification,
  IconOrder,
  IconPromo,
} from '@/styles/Icon'
import { Dialog, Transition } from '@headlessui/react'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { Fragment, useEffect, useMemo, useState } from 'react'
interface BottomNavigationType {
  layout: string
  page: string
}

const ComparePopup = dynamic(() => import('../components/Popup/ComparePopup'), {
  ssr: false,
})

const ChooseProductCompare = dynamic(
  () => import('../components/Popup/ChooseProductCompare'),
  {
    ssr: false,
  }
)

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const BottomNavigation = ({ layout, page }: BottomNavigationType) => {
  const [active, setActive] = useState(1)
  const router = useRouter()
  const { token, cart, channel } = useAuth()
  const [open, setOpen] = useState(false)
  const { systemConfig } = useNotification()
  const {
    megaMenu,

    isOpenAddComparePopup,
    setProductCompares,
    productCompares,
    setIsOpenAddComparePopup,
    isOpenComparePopup,
    setIsOpenComparePopup,
    productViewed,
    catViewId,
  } = useStore()
  const onDevelopment = () => bus.emit(EventBus.DEVELOPMENT_MODAL, true)
  const scrollToTop = () => {
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
  }

  const handleActive = (item: number) => {
    setActive(item)
    if (item === 1) {
      if (router.pathname == '/') {
        scrollToTop()
      }
      router.push('/')
    } else if (item === 2) {
      setOpen(true)
    } else if (item === 3) {
      router.push('/hot-deal')
    } else if (item === 4) {
      router.push('/checkout/cart')
    } else if (item === 5) {
      router.push('/search-order')
    }
  }
  const closeModal = () => {
    setOpen(false)
  }

  useEffect(() => {
    if (router.pathname == '/') {
      setActive(1)
    }
  }, [router.pathname])

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const footerHomePage = useMemo(() => {
    return (
      <>
        <div
          className={`fixed bottom-0 left-[50%] z-[999] flex h-[68px] w-full max-w-[440px] translate-x-[-50%] items-center justify-between bg-white shadow-100`}
          id='bottomMobileTab'
        >
          <div
            className={`flex flex-5 flex-wrap items-center justify-center text-center text-[13px] font-light`}
            onClick={() => handleActive(2)}
          >
            <span className='flex h-[28px] w-max items-center justify-center'>
              <IconCategory />
            </span>
            <p
              className={`w-full text-dark-900 ${active === 2 ? 'block' : ''}`}
            >
              Danh mục
            </p>
          </div>
          {channel === SaleChannel.B2E ? (
            <div
              className={`flex flex-5 flex-wrap items-center justify-center text-center text-[13px] font-light`}
              onClick={() => onDevelopment()}
            >
              <span className='flex h-[28px] w-max items-center justify-center'>
                <IconNotification />
              </span>
              <p
                className={`w-full text-dark-900 ${
                  active === 4 ? 'block' : ''
                }`}
              >
                Thông báo
              </p>
            </div>
          ) : (
            <div
              className={`flex flex-5 flex-wrap items-center justify-center text-center text-[13px] font-light`}
              onClick={() => handleActive(3)}
            >
              <span className='flex h-[28px] w-max items-center justify-center'>
                <IconPromo />
              </span>
              <p
                className={`w-full text-orange ${active === 3 ? 'block' : ''}`}
              >
                Khuyến mãi
              </p>
            </div>
          )}

          <div
            className='flex flex-5 flex-wrap items-center justify-center text-center'
            onClick={() => handleActive(1)}
          >
            <span className='relative mt-[-44px]'>
              <ImageOptimize
                className='h-[70px] w-auto border-4 rounded-full border-red-800/10'
                alt={systemConfig?.websiteBrandName || ''}
                src={systemConfig?.companyLogoButton || ''}
                width={110}
                height={70}
                priority
                loading='eager'
              />
            </span>
            <p
              className={`w-full text-[13px] font-bold mt-[2px] ${
                active === 1 ? 'text-blue' : ''
              }`}
            >
              Trang chủ
            </p>
          </div>
          <div
            className={`relative flex flex-5 flex-wrap items-center justify-center text-center text-[13px] font-light`}
            onClick={() => handleActive(4)}
          >
            <div className='relative flex h-[28px] w-max items-center justify-center'>
              <IconCart />
              {cart && cart.quantity != 0 && (
                <div
                  className={
                    'absolute right-[-6px] top-[-3px] z-10 block h-[18px] w-[18px] rounded-full bg-red text-[10px] font-normal leading-[18px] text-white'
                  }
                >
                  {cart && cart.quantity && cart.quantity > 9
                    ? '9+'
                    : cart.quantity}
                </div>
              )}
            </div>
            <p
              className={`w-full text-dark-900 ${active === 4 ? 'block' : ''}`}
            >
              Giỏ hàng
            </p>
          </div>
          <div
            className={`flex flex-5 flex-wrap items-center justify-center text-center text-[13px] font-light`}
            onClick={() => handleActive(5)}
          >
            <span className='flex h-[28px] w-max items-center justify-center'>
              <IconOrder />
            </span>
            <p
              className={`w-full text-dark-900 ${active === 5 ? 'block' : ''}`}
            >
              Đơn hàng
            </p>
          </div>
        </div>
        <Transition.Root show={open} as={Fragment}>
          <Dialog as='div' className='relative  z-[9999]' onClose={setOpen}>
            <Transition.Child
              as={Fragment}
              enter='ease-in-out duration-500'
              enterFrom='opacity-0'
              enterTo='opacity-100'
              leave='ease-in-out duration-500'
              leaveFrom='opacity-100'
              leaveTo='opacity-0'
            >
              <div className='fixed inset-0 left-0 bg-gray-500 bg-opacity-75 transition-opacity' />
            </Transition.Child>

            <div className='fixed inset-0 overflow-hidden'>
              <div className='pointer-events-none fixed inset-y-0 left-[50%] translate-x-[-50%] flex max-w-[440px]'>
                <Transition.Child
                  as={Fragment}
                  enter='transform transition ease-in-out duration-500 sm:duration-700'
                  enterFrom='translate-x-[-100%] opacity-0'
                  enterTo='translate-x-[0%] opacity-100'
                  leave='transform transition ease-in-out duration-500 sm:duration-700'
                  leaveFrom='translate-x-[0%] opacity-100'
                  leaveTo='translate-x-[-100%] opacity-0'
                >
                  <Dialog.Panel className='pointer-events-auto w-screen max-w-md'>
                    <div className='flex h-full flex-col bg-white relative'>
                      <span
                        className='absolute block right-4 z-10 top-9'
                        onClick={closeModal}
                      >
                        <IconClose />
                      </span>
                      <MenuWrapper
                        megaMenuData={megaMenu}
                        closeModal={closeModal}
                      />
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      </>
    )
  }, [token, cart, open, megaMenu])

  return (
    <section>
      {(layout === PageType.CATEGORY || page === 'product-detail' || layout === 'product-compare') && (
        <>
          <ComparePopup
            open={isOpenComparePopup}
            setIsOpenComparePopup={setIsOpenComparePopup}
            setProductCompares={setProductCompares}
            setIsOpenAddComparePopup={setIsOpenAddComparePopup}
            productCompares={productCompares}
          />
          <ChooseProductCompare
            catViewId={catViewId}
            productViewed={productViewed}
            isOpen={isOpenAddComparePopup}
            setIsOpenComparePopup={setIsOpenComparePopup}
            setProductCompares={setProductCompares}
            productCompares={productCompares}
            setIsOpen={setIsOpenAddComparePopup}
          />
        </>
      )}
    </section>
  )
}

export default BottomNavigation
